<template>
  <vx-card
    :title="$t('class-over-view.instruction')"
    title-color="primary"
    class="mb-base"
  >

    <template slot="actions">
      <vs-chip transparent color="primary" >
        <vs-avatar class="bg-primary cursor-default" :text="String(subject.creditCalGrade)"/>{{ $t('student-enroll.credit') }}
      </vs-chip>


    </template>
    <div class="p-1 mb-2">
      {{ courseOutline.instruction ? courseOutline.instruction:'-' }}
    </div>
  </vx-card>
</template>

<script>
    export default {
      props:{
        classRoom: Object
      },
      computed:{
        courseOutline(){
          return this.classRoom ? this.classRoom.courseOutlineRegistration.courseOutline:{}
        },
        subject(){
          return this.classRoom ? this.classRoom.subject:{}
        },
      }
    }
</script>

<style scoped>

</style>
